import React from 'react';
import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
// TODO:  Using the linear tokens to create the circular tokens
// Ann will create the circular tokens
const StyledCircularProgress = styled((props) => React.createElement(CircularProgress, Object.assign({}, props)))(({ theme }) => ({
    backgroundColor: 'transparent',
    '& .MuiCircularProgress-svg': {
        color: theme.palette.linearProgress.fill.background.default
    }
}));
const BDSCircularProgress = props => {
    return React.createElement(StyledCircularProgress, Object.assign({}, props));
};
export default BDSCircularProgress;
//# sourceMappingURL=CircularProgress.js.map